<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'!text-red-600': !loading && isActive, 'muted': !isActive}"
    :text="$t('Delete file permanently')"
    :loading="loading"
    icon="trash"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { showConfirm } from '../BcConfirm'
import { trackEvent } from '../../gtm'
import { TrashApi } from '@/frontapp/test-api'
import useBcFileStore from '@/frontapp/store/bcFile'
import handleApiError from '../../utils/handleApiError'

const trashApi = new TrashApi({}, '/api/v2')

export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    isActive() {
      return this.bcSelectedStore.listSelected.length > 0
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore)
  },
  methods: {
    async click() {
      const confirm = await showConfirm({
        header: this.$t('Do you want to permanently delete selected files?')
      })

      if (!confirm) {
        return
      }

      this.loading = true

      let fileIds = this.bcSelectedStore.listSelected.map((el) => el.id)
      await handleApiError(() => trashApi.trashDeleteFilePermanently({ fileIds: fileIds }))

      const bcFileStore = useBcFileStore()
      fileIds.forEach((id) => {
        bcFileStore.deleteFile(id)
      })

      this.bcSelectedStore.resetSelected()

      this.loading = false
      trackEvent(this.$route.matched[0].name, 'deleteFileFromTrash')

    }
  }
}
</script>

<style lang="scss" scoped></style>
